import React from "react";
import PropTypes from "prop-types";

const InlineError = ({ text }) => (
	<span className="help-block">{text}</span>
);
InlineError.propTypes ={
	text: PropTypes.string.isRequired
};
export default InlineError;


// WEBPACK FOOTER //
// ./src/components/messages/InlineError.js